// @ts-strict-ignore
import { FC, useEffect, useState } from 'react';
import {
  Area,
  Bar,
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  Tooltip,
  XAxis,
  XAxisProps,
  YAxis,
  YAxisProps,
} from 'recharts';
import { paletteT50 as colors } from '../shared/colorPalettes';
import { legendWrapperStyles } from '../shared/constants';
import { DataConverters } from '../shared/dataConverters';
import { ReportConvertedData, ReportProps } from '../shared/dataTypes';
import { useChartOpacity } from './helpers/chartingHelpers';

const ComposedChartViz: FC<ReportProps> = props => {
  const [opacity, , onChartEnter, onChartLeave] = useChartOpacity({});
  const [reportConvertedData, setReportConvertedData] = useState<ReportConvertedData>();

  useEffect(() => setReportConvertedData(DataConverters.COMPOSED_CHART(props.reportRawData)), [
    props.reportRawData,
  ]);

  if (props.width <= 0 || props.height <= 0 || !reportConvertedData) {
    return null;
  }

  const composedChartData = reportConvertedData.rows;

  const isInverted = props.isInverted;

  const xAxisProps: XAxisProps = isInverted
    ? { type: 'number' }
    : { dataKey: reportConvertedData.groupingHeader.name };
  const yAxisProps: YAxisProps = isInverted
    ? { dataKey: reportConvertedData.groupingHeader.name, type: 'category' }
    : {};

  return (
    <ComposedChart
      layout={isInverted ? 'vertical' : 'horizontal'}
      width={props.width}
      height={props.height}
      data={composedChartData}
      margin={{ left: 30 }}
      onClick={event =>
        event &&
        props.onElementClick(
          event.activePayload[0].payload[`${event.activePayload[0].name}rowcol`],
        )(event)
      }
    >
      <CartesianGrid stroke='#f5f5f5' />
      <XAxis {...xAxisProps} />
      <YAxis {...yAxisProps} />
      <Tooltip formatter={(value, name, props) => props.payload[`${name}Formatted`]} />
      <Legend
        layout='vertical'
        align='right'
        verticalAlign='top'
        wrapperStyle={legendWrapperStyles.vertical}
        onMouseEnter={onChartEnter(reportConvertedData.headers)}
        onMouseLeave={onChartLeave}
      />
      <Area
        type='monotone'
        dataKey={reportConvertedData.headers[0]}
        fill={colors[0]}
        stroke={colors[0]}
        fillOpacity={opacity[reportConvertedData.headers[0]] || 1}
      />
      {reportConvertedData.headers[1] && (
        <Bar
          dataKey={reportConvertedData.headers[1]}
          barSize={20}
          fill={colors[1]}
          fillOpacity={opacity[reportConvertedData.headers[1]] || 1}
        />
      )}
      {reportConvertedData.headers[2] && (
        <Line
          type='monotone'
          dataKey={reportConvertedData.headers[2]}
          stroke={colors[2]}
          strokeOpacity={opacity[reportConvertedData.headers[2]] || 1}
        />
      )}
    </ComposedChart>
  );
};

export default ComposedChartViz;
